/**
 * Rate limits for geo API services (requests per second)
 * @see https://geo.api.gouv.fr/
 */

export const GEO_RATE_LIMITS = {
  adminDivision: 10,
  geocodingSimple: 50,
  geocodingBulk: 2,
} as const;
